import { Overlay } from '@angular/cdk/overlay';
import { Component} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CompanyApiService } from 'src/app/services/api/company-api.service';
import { LeadApiService } from 'src/app/services/api/lead-api.service';
import { BasicInfoService } from 'src/app/services/basic-info.service';
import { FlowService } from 'src/app/services/flow.service';
import { LocaleService } from 'src/app/services/locale.service';
import { PersonalInfoService } from 'src/app/services/personal-info.service';
import { StorageService } from 'src/app/services/storage.service';
import { TrackingService } from 'src/app/services/tracking.service';
import { BasicInfoScreenComponent } from '../basic-info-screen/basic-info-screen-nl.component';

@Component({
  selector: 'app-big-ticket',
  templateUrl: './big-ticket-nl.component.html',
  styleUrls: ['./big-ticket.component.scss']
})

export class BigTicketComponent extends BasicInfoScreenComponent {
  constructor(
    protected basicInfoService: BasicInfoService,
    protected formBuilder: FormBuilder,
    protected companyApi: CompanyApiService,
    protected leadApi: LeadApiService,
    protected translateService: TranslateService,
    protected personalInfoService: PersonalInfoService,
    protected trackingService: TrackingService,
    protected localeService: LocaleService,
    protected storageService: StorageService,
    protected route: ActivatedRoute,
    public flowService: FlowService,
    protected dialog: MatDialog,
    protected overlay: Overlay
  ) { 
      super(
        basicInfoService,
        formBuilder,
        companyApi,
        leadApi,
        translateService,
        personalInfoService,
        trackingService,
        localeService,
        storageService,
        route,
        flowService,
        dialog,
        overlay
      ) 
    }
}
